// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2zkSq","content":"GlobalSearch_content__gfH4B"};